import React, { FC } from "react";

import { ExpandedRowProps } from "./types";
import ExpandedRowBody, {
  ListGroup,
  TextGroup,
} from "../../../../components/ExpandedRow";

export const ExpandedRow: FC<ExpandedRowProps> = ({
  comment,
  entitlements,
}) => {
  return (
    <ExpandedRowBody>
      <TextGroup label="Comments" text={comment} />
      <ListGroup
        label="Entitlements"
        list={entitlements
          .filter((item) => {
            return !!item.summary;
          })
          .map((item) => {
            if (item.requires_value) {
              return `${item.summary}: ${
                item.value === 0 ? "Unlimited" : item.value
              }`;
            }
            return `${item.summary}`;
          })
          .sort()}
      />
    </ExpandedRowBody>
  );
};
